enum OutroType {
    PulseSurveyRedirect = "PulseSurveyRedirect",
    PreviewCompleted = "PreviewCompleted",
    RecognitionSentRedirect = "RecognitionSentRedirect",
    MultipleRecipientsRecognitionSentRedirect = "MultipleRecipientsRecognitionSentRedirect",
    RecognitionSkippedRedirect = "RecognitionSkippedRedirect"
}

export default OutroType;